import {HttpError, InterpretedError, NetworkError} from "../errors/Errors";

export function actionFromError(type, e) {
  let error = {};

  if(e instanceof InterpretedError) {
    if(e instanceof HttpError) {
      error = {
        type: 'HttpError',
        status: e.status,
        message: e.message
      }
    } else if(e instanceof NetworkError) {
      error = {
        type: 'NetworkError',
        message: e.message
      }
    } else {
      error = {
        type: 'InterpretedError',
        message: e.message
      }
    }
  } else {
    error = {
      type: 'Error',
      message: e.message
    }
  }


  return {
    type,
    error: true,
    payload: error,
    meta: {
        isInterpretedError: true
    }
  }
}


// WEBPACK FOOTER //
// ./src/actions/ActionUtils.js